import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
  discountBadge?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK TANGO LISTO',
  description: '6 tomos + 6 bonos completos',
  originalPrice: '$51.000',
  price: '$19.990',
  ctaText: 'SÍ, QUIERO MI MEGAPACK →',
  ctaHref: 'https://www.profepack.com/cart/48163872211200:1',
  discountBadge: '-61%'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + ECOSISTEMA DEL ALUMNO PRO',
  description: 'Todo el MegaPack + Cuaderno, Diccionario Visual, Guía de Milonga, Bitácora, 50 Infografías y Certificados',
  originalPrice: '$69.000',
  price: '$27.990',
  ctaText: 'SÍ, QUIERO EL MEGAPACK + ECOSISTEMA DEL ALUMNO PRO →',
  ctaHref: 'https://www.profepack.com/cart/48163895509248:1',
  isFeatured: true,
  savings: 'AHORRÁS $41.010',
  discountBadge: '-59%'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-24 px-4 overflow-hidden" data-id="element-172">
      <div className="max-w-xl mx-auto relative" data-id="element-173">
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C8962E]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-174" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative z-10" data-id="element-175">
          <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1.5 sm:mb-3" data-id="element-176">
            Elegí tu{' '}
            <span className="text-[#C8962E]" data-id="element-177">MegaPack Tango Listo:</span>
          </h2>
          <p className="text-gray-400 text-center text-xs sm:text-base mb-5 sm:mb-12" data-id="element-178">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>

          <div className="space-y-3 sm:space-y-5 mb-5 sm:mb-10" data-id="element-179">
            {options.map(option => {
            const isSelected = selected === option.id;
            const isFeatured = option.isFeatured;
            return <motion.button key={option.id} onClick={() => setSelected(option.id)} className={`relative w-full text-left rounded-2xl p-3.5 sm:p-6 transition-all duration-300 ${isSelected ? isFeatured ? 'bg-[#1a1500] border-2 border-[#C8962E] shadow-[0_0_40px_rgba(200,150,46,0.15)]' : 'bg-[#1a1a1a] border-2 border-white/40 shadow-lg' : 'bg-[#141414] border-2 border-white/5 hover:border-white/20 hover:bg-[#1a1a1a]'}`} whileHover={{
              scale: isSelected ? 1 : 1.01
            }} whileTap={{
              scale: 0.99
            }} data-id="element-180">
                  {/* Featured Ribbon */}
                  {isFeatured && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#C8962E] to-[#eab308] text-black text-[10px] sm:text-xs font-black px-3 sm:px-4 py-0.5 sm:py-1 rounded-full shadow-lg border border-[#fef08a]/50 whitespace-nowrap z-20" data-id="element-181">
                      ⭐ MÁS ELEGIDO
                    </div>}

                  {/* Featured Glow Outline */}
                  {isFeatured && isSelected && <motion.div className="absolute inset-0 rounded-2xl border-2 border-[#C8962E] pointer-events-none" animate={{
                opacity: [0.5, 1, 0.5]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-182" />}

                  <div className="flex items-start sm:items-center gap-3 sm:gap-4 relative z-10" data-id="element-183">
                    {/* Radio Circle */}
                    <div className="mt-0.5 sm:mt-0 relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex-shrink-0 transition-colors duration-300" data-id="element-184">
                      <div className={`absolute inset-0 rounded-full border-2 transition-colors duration-300 ${isSelected ? isFeatured ? 'border-[#C8962E]' : 'border-white' : 'border-white/20'}`} data-id="element-185" />
                      <AnimatePresence data-id="element-186">
                        {isSelected && <motion.div initial={{
                      scale: 0
                    }} animate={{
                      scale: 1
                    }} exit={{
                      scale: 0
                    }} transition={{
                      type: 'spring',
                      stiffness: 500,
                      damping: 30
                    }} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${isFeatured ? 'bg-[#C8962E]' : 'bg-white'}`} data-id="element-187" />}
                      </AnimatePresence>
                    </div>

                    <div className="flex-1 min-w-0" data-id="element-188">
                      <div className="flex items-center gap-1.5 sm:gap-2 mb-0.5 sm:mb-1 flex-wrap" data-id="element-189">
                        <span className="text-base sm:text-xl" data-id="element-190">
                          {option.emoji}
                        </span>
                        <span className="text-white font-black text-sm sm:text-lg leading-tight" data-id="element-191">
                          {option.title}
                        </span>
                      </div>

                      <p className="text-gray-400 text-[11px] sm:text-sm leading-snug sm:leading-relaxed pr-1 sm:pr-2" data-id="element-192">
                        {option.description}
                      </p>

                      {isFeatured && option.savings && <div className="mt-1.5 sm:mt-2.5 inline-block" data-id="element-193">
                          <span className="bg-[#C8962E]/10 text-[#C8962E] text-[10px] sm:text-xs font-bold px-2 sm:px-2.5 py-0.5 sm:py-1 rounded-md border border-[#C8962E]/20" data-id="element-194">
                            {option.savings}
                          </span>
                        </div>}
                    </div>

                    <div className="text-right flex-shrink-0 flex flex-col items-end justify-center" data-id="element-195">
                      <div className="flex items-center gap-1 sm:gap-1.5 mb-0.5" data-id="element-196">
                        <span className="text-gray-500 line-through text-[11px] sm:text-sm font-medium" data-id="element-197">
                          {option.originalPrice}
                        </span>
                        <span className="bg-red-500/20 text-red-500 text-[9px] sm:text-[10px] font-black px-1 sm:px-1.5 py-0.5 rounded" data-id="element-198">
                          {option.discountBadge}
                        </span>
                      </div>
                      <div className={`font-black text-xl sm:text-3xl tracking-tight ${isFeatured ? 'text-[#C8962E]' : 'text-white'}`} data-id="element-199">
                        {option.price}
                      </div>
                    </div>
                  </div>
                </motion.button>;
          })}
          </div>

          {/* Social Proof Line */}
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4" data-id="element-200">
            <span className="relative flex h-2 w-2" data-id="element-201">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-202" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-203" />
            </span>
            <p className="text-gray-300 text-xs sm:text-sm font-medium" data-id="element-204">
              <strong className="text-white" data-id="element-205">47 profes</strong> lo eligieron
              esta semana
            </p>
          </div>

          {/* CTA Button */}
          <motion.a href={selectedOption.ctaHref} className="btn-green-pulse green-shimmer relative block w-full text-center bg-[#C8962E] text-black font-black text-base sm:text-xl py-3.5 sm:py-5 rounded-2xl shadow-[0_0_40px_rgba(200,150,46,0.25)] hover:shadow-[0_0_60px_rgba(200,150,46,0.4)] transition-shadow" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-206">
            {selectedOption.ctaText}
          </motion.a>

          {/* Description Text */}
          <AnimatePresence mode="wait" data-id="element-207">
            <motion.p key={selected} initial={{
            opacity: 0,
            y: 5
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -5
          }} transition={{
            duration: 0.2
          }} className="text-gray-400 text-[11px] sm:text-sm text-center mt-3 sm:mt-5 italic px-2 sm:px-4" data-id="element-208">
              {selected === 'elite' ? 'La opción más elegida por profes que quieren entregar material profesional a sus alumnos y diferenciarse completamente de la competencia.' : 'El sistema completo para enseñar tango en todos los niveles.'}
            </motion.p>
          </AnimatePresence>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 mt-5 sm:mt-10" data-id="element-209">
            {[{
            icon: '🔒',
            text: 'Pago seguro'
          }, {
            icon: '⚡',
            text: 'Acceso en 5 min'
          }, {
            icon: '🛡️',
            text: 'Garantía 7 días'
          }, {
            icon: '💳',
            text: 'Mercado Pago'
          }].map((badge, i) => <div key={i} className="flex items-center gap-1 sm:gap-1.5 bg-white/[0.03] border border-white/[0.05] rounded-lg px-2.5 sm:px-3 py-1.5 sm:py-2" data-id="element-210">
                <span className="text-xs sm:text-sm" data-id="element-211">{badge.icon}</span>
                <span className="text-gray-300 text-[10px] sm:text-xs font-medium" data-id="element-212">
                  {badge.text}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}